import React from 'react';
import triangulos from '../assets/img/triangulos.png';
import triangulos_colores from '../assets/img/triangulos_colores.png';

class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state={}
  }

  componentDidMount(){
  }

  render(){
    return(
      <div className="Todo Index" style={{display:'flex', flexDirection:'column', alignItems:'flex-start', justifyContent:'flex-start'}}>
        <div style={{margin:20, display:'flex', flexDirection:'column'}}>
          <div style={{display:'flex', flexDirection:'column', marginBottom:40}}>
            <div style={{display:'flex', flexDirection:'row'}}>
              <div style={{display:'flex', flexDirection:'column'}}>
                <span className="Titulo">sistema de ubicación</span>
                <span className="Subitulo">ENTREGA DE MÓDULOS</span>
              </div>
              <img
                style={{position:'relative', paddingTop:30}}
                src={triangulos_colores}
                height={70}
                className="Logo"
                alt="Logo"
              />
            </div>
            <span className="InfoExtra">Ministerio de Desarrollo Humano</span>
          </div>
          <span className="CuerpoTexto">
            Sistema de geolocalización para la entrega de módulos
          </span>
        </div>

        <img
          style={{position:'absolute', right:50, top:-130, zIndex:-1}}
          src={triangulos}
          height={600}
          className="Logo"
          alt="Logo"
        />
      </div>
    );
  }
}

export default Index;
